import { render } from "./EssayWriting.vue?vue&type=template&id=1228c20c&scoped=true"
import script from "./EssayWriting.vue?vue&type=script&lang=js"
export * from "./EssayWriting.vue?vue&type=script&lang=js"

import "@/assets/css/essayWritingView.sass?vue&type=style&index=0&id=1228c20c&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1228c20c"]])

export default __exports__